import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
require('datatables.net');
require('datatablesResponsive');

export class latestNews {
	$newsDatatable: any;
	searchForm(): void {
		let _self = this;
		let $newsTable:any = _self.$newsDatatable;
		let $newsContainer:any = $('#news');
		let $mediaContainer:any = $('#media');

		_self.initFilterYearSel($newsContainer);
		_self.initFilterYearSel($mediaContainer);

		_self.initFilterNewsSel($newsContainer);
		_self.initFilterNewsSel($mediaContainer);
	}

	initFilterYearSel(container:any): void {
		let $filterByYear: any = container.find('.filterByYear');
		let $filterByYearSel:any = container.find('.news-year--filter');
		let $newsTableId:any = container.find('.news-feed-list')[0].id;
		let $newsDataTable = $.fn.dataTable.Api("#"+$newsTableId);
		// init selectize on from news year filter
		$filterByYearSel.selectize({
			onInitialize: function() {
				let value:any = $filterByYearSel.find('option:first-child').attr('value');
				$newsDataTable.column(0).search(value).draw();
			},
			onFocus: function() {
				$filterByYear.find('.booking-form--title').addClass('input-filled');
				$filterByYear.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$filterByYearSel.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$filterByYearSel.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function(value:any) {
					$(this).find('.booking-form--title').addClass('input-filled');
					$(this).find('.selectize-control.single .selectize-input').addClass('select-filled');

					// search data table using country value returned from selectize
					$newsDataTable.column(0).search(value).draw();
			},
			onBlur: function(){
			},
			selectOnTab: true
		});
	}

	initFilterNewsSel(container:any):void {
		let $filterByNews: any = container.find('.filterByNews');
		let $filterByNewsSel:any = container.find('.news-content--filter');
		let $newsTableId:any = container.find('.news-feed-list')[0].id;
		let $newsDataTable = $.fn.dataTable.Api("#"+$newsTableId);

		// init selectize on news content filter
		$filterByNewsSel.selectize({
			onInitialize: function() {
				let value:any = $filterByNewsSel.find('option:first-child').attr('value');
				$newsDataTable.column(1).search(value).draw();
				if (value.toLowerCase() !== 'all') {
					$newsDataTable.column(1).search(value).draw();
				} else {
					$newsDataTable.column(1).search('').draw();
				}
			},
			onFocus: function() {
				$filterByNews.find('.booking-form--title').addClass('input-filled');
				$filterByNews.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$filterByNewsSel.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$filterByNewsSel.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function(value:any) {
					$filterByNews.find('.booking-form--title').addClass('input-filled');
					$filterByNews.find('.selectize-control.single .selectize-input').addClass('select-filled');

					// search data table using country value returned from selectize
					if (value.toLowerCase() !== 'all') {
						$newsDataTable.column(1).search(value).draw();
					} else {
						$newsDataTable.column(1).search('').draw();
					}
			},
			onBlur: function(){
			},
			selectOnTab: true
		});
	}

	newsFilter(): void {
		let _self = this;
		let target:any
		target = $('.latest-news li a').attr('data-feed');
		let $newsFeedTable:any = $('.news-feed-list');
		$newsFeedTable.each(function() {
			let $newsFeedContainerDate:any = $('.news-feed--container table tbody tr td:first-child');
			$newsFeedContainerDate.each(function() {
				let $newsFeedContainerDateLabel:any = $(this).find('label').html();
				let $dateParse = Date.parse($newsFeedContainerDateLabel);
				$(this).attr('data-order', $dateParse);
			});
			let $newTableInstance = $(this);
			let $newDatatable = $newTableInstance.DataTable({
				bLengthChange: false,
				order: [[0, 'desc']]
			});
		});

		$('a[data-toggle="tab"]').on( 'shown.bs.tab', function (e:any) {
				$.fn.dataTable.tables( {visible: true, api: true} ).columns.adjust();
		});

		$('.news-feed--container .paginate_button').on('click', () =>{
			$('html, body').animate({ scrollTop: 0 }, 'slow');
			return false;
		});
	}
}

let scope:Element = document.querySelector('.latest-news');
if (scope){
	try {
		let latestnews = new latestNews();
				latestnews.newsFilter();
				latestnews.searchForm();
	} catch(e) {console.error(e);}
}
